<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="19.999" height="20" viewBox="0 0 19.999 20">
    <path class="a" d="M11953.655,7420.658A8,8,0,1,1,11956,7415a7.97,7.97,0,0,1-2.344,5.658L11958,7425Z"
          transform="translate(-11939 -7405.999)"/>
  </svg>
</template>

<script>
export default {
  name: 'FindIcon'
}
</script>

<style scoped>
svg .a {
  fill: none;
  stroke: #fff;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}
</style>
